/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { FC, useEffect, useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { withProcedureWraper } from "..";
import { Routes } from "../../../AppRoutes";
import { Box } from "../../../components/box";
import { Icon } from "../../../components/icon";
import { InputDateTime, InputSelect, InputText, InputNumber, InputTextArea } from "../../../components/input";
import { InputCheckbox } from "../../../components/input/checkbox";
import { CreateNotification } from "../../../components/notifier";
import { Button } from "../../../modules/button";
import { InputWraper, useForm } from "../../../modules/form";
import { leaveRequestOptions } from "../../../store/data";
import { getDay, getLocalDate, getDiffDay, getTotalDay, setUtcTime } from "../../../helper/dateTimeHelper";
import { useSelector } from "react-redux";
import { LeaveRequestService } from "../../../services/leave-request/leaveRequest.service";
import { EmployeeService } from "../../../services/employee/employee.service";
import { UserSelect } from "../../../components/input/select/UserSelect";
import { MailService } from "../../../services/mail/mail.service";
import { getEnv } from "../../../AppConfigs";
import { mailRegexs } from "../../../constants/mailTemplateConstants";
import { requestStatus } from "../../../constants/statusConstants";
import { Col, Container, Row } from "react-bootstrap";
import { fetchEmployees } from "../../../actions/employeeActions";

const siteUrl = getEnv("REACT_APP_APPROVER_LEAVE_REQUESTS_URL");

export const LeaveRequestCreatePage: FC = withProcedureWraper(() => {
  const history = useHistory();
  const employees = useSelector((state: any) => state.employee.employees);
  const mailtemplates = useSelector((state: any) => state.systemMgmt.mailtemplates);
  const user = useSelector((state: any) => state.user);
  const currentUserName = user?.current?.username;
  const { id } = useRouteMatch().params as any;
  const today = new Date();
  const [leaveType, setLeaveType] = useState(leaveRequestOptions[0].value);
  const [approver, setApprover] = useState("");
  const [preApprover, setPreApprover] = useState("");
  const [currentUser, setCurrentUser] = useState(null as any);
  const [approverOptions, setApproverOptions] = useState([]);
  const [preApproverOptions, setPreApproverOptions] = useState([]);
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today);
  const [minDate, setMinDate] = useState(today);
  const [employeeids, setEmployeeids] = useState([]);

  const { getInputProps, handleSubmit, isSubmitting, values, setValues } = useForm({
    structure: [
      {
        name: "fullname",
        label: "Họ và tên",
      },
      {
        name: "role",
        label: "Chức vụ",
      },
      {
        name: "department",
        label: "Phòng ban",
      },
      {
        name: "address",
        label: "Địa chỉ liên lạc",
      },
      {
        name: "phone",
        label: "Số điện thoại",
      },
      {
        name: "type",
        label: "Loại nghỉ",
      },
      {
        name: "approver",
        label: "Người duyệt thứ hai",
      },
      {
        name: "preapprover",
        label: "Người duyệt thứ nhất",
      },
      {
        name: "from",
        label: "Ngày bắt đầu",
      },
      {
        name: "fromSession",
        defaultValue: ["SA", "CH"],
      },
      {
        name: "to",
        label: "Ngày kết thúc",
      },
      {
        name: "toSession",
        defaultValue: ["SA", "CH"],
      },
      {
        name: "reason",
        label: "Lý do nghỉ",
      },
    ],
    onSubmit: async (payload) => {
      const { fromSession, toSession, reason } = payload;
      const approverTmp = employees.find((f: any) => f.eMail === approver);
      const preApproverTmp = employees.find((f: any) => f.eMail === preApprover);
      let startTime = 0;
      let endTime = 0;
      if (fromSession.length === 1) {
        startTime = fromSession[0] === "SA" ? 8 : 13;
      }
      if (toSession.length === 1) {
        endTime = toSession[0] === "SA" ? 8 : 13;
      }
      const start = startDate.setHours(startTime, 0, 0);
      const end = endDate.setHours(endTime, 0, 0);
      const duration = getTotalDay(getLocalDate(start), getLocalDate(end));
      const leaveRequest: any = {
        fields: {
          Title: `Đơn nghỉ phép - ${currentUser.Title}`,
          eLeaveStartDate: setUtcTime(getDay(start)),
          eLeaveEndDate: setUtcTime(getDay(end)),
          eDuration: parseFloat(duration.toString()).toFixed(1),
          eLeaveType: leaveType,
          eLeaveReason: reason,
          ePreApprovedBy: preApproverTmp ? `${preApproverTmp.eMail}|${preApproverTmp.Title}` : null,
          eApprovedBy: approverTmp ? `${approverTmp.eMail}|${approverTmp.Title}` : null,
          eRquestStatus: requestStatus.submitted,
        },
      };
      addLeaveRequest(leaveRequest);
      updateEmployee(payload);
    },
  });

  const sendMail = async (approver: any) => {
    const arr = approver.split("|");
    const name = arr.length > 1 ? arr[1] : "";
    const tomail = arr.length > 1 ? arr[0] : "";
    const template = mailtemplates.find((m: any) => m.eMailType === "LRA");
    const content = template.eContent.replace(mailRegexs.zero, name).replace(mailRegexs.siteUrl, siteUrl);
    const subject = template.eSubject;
    const message = MailService.buildMailMesssage(subject, content, "html", tomail);
    await MailService.sendMail(message);
  };

  const updateEmployee = (payload: any) => {
    const employee: any = employeeids.find((o: any) => o.fields.eMail === currentUser.eMail) || null;
    if (employee) {
      const { id, fields } = employee;
      fields.Title = payload.fullname;
      fields.eDepartment = payload.department;
      fields.ePhone = payload.phone;
      fields.eBizTitle = payload.role;
      fields.eAddress = payload.address;
      EmployeeService.updateEmployee(id, fields).then(
        (res) => {
          fetchEmployees();
        },
        (err) => {
          console.log(err);
        },
      );
    }
  };

  const addLeaveRequest = (leaveRequest: any) => {
    if (id != 0) {
      LeaveRequestService.updateLeaveRequest(id, leaveRequest.fields).then(
        (res) => {
          CreateNotification({
            title: "Thành công",
            body: `Chỉnh sửa yêu cầu thành công.`,
            icon: "/icons/success.png",
          });
          history.push(Routes.procedureLeaveRequest.path);
        },
        (error) => {
          CreateNotification({ title: "Thất bại", body: `Chỉnh sửa yêu cầu thất bại.`, icon: "/icons/error.png" });
          console.log(error);
        },
      );
    } else {
      LeaveRequestService.addLeaveRequest(leaveRequest).then(
        (res) => {
          CreateNotification({ title: "Thành công", body: `Tạo yêu cầu thành công.`, icon: "/icons/success.png" });
          if (leaveRequest.fields.eApprovedBy) {
            sendMail(leaveRequest.fields.eApprovedBy);
          }
          if (leaveRequest.fields.ePreApprovedBy) {
            sendMail(leaveRequest.fields.ePreApprovedBy);
          }
          history.push(Routes.procedureMyLeaveRequest.path);
        },
        (error) => {
          CreateNotification({ title: "Thất bại", body: `Tạo yêu cầu thất bại.`, icon: "/icons/error.png" });
          console.log(error);
        },
      );
    }
  };

  const onLeaveTypeChange = (selectedOptions: any) => {
    setLeaveType(selectedOptions ? selectedOptions.value : "");
  };

  const onPreApproverChange = (selectedOptions: any) => {
    setPreApprover(selectedOptions ? selectedOptions.value : "");
  };

  const onApproverChange = (selectedOptions: any) => {
    setApprover(selectedOptions ? selectedOptions.value : "");
  };

  const onStartDateChange = (date: any) => {
    const newDate = new Date(date);
    setStartDate(newDate);
    const days = getDiffDay(getLocalDate(newDate), getLocalDate(getDay(endDate)));
    if (days < 0) {
      setEndDate(newDate);
    }
    setTimeout(() => setMinDate(newDate), 0);
  };

  const onEndDateChange = (date: any) => {
    setEndDate(new Date(date));
  };

  const checkCurrentUser = () => {
    const currentUser = employees.find((o: any) => o.eMail.toLowerCase() === currentUserName.toLowerCase());
    setCurrentUser(currentUser);
  };

  const getApproverOptions = () => {
    let preApproverTitleCode = "DT,DP";
    let approverTitleCode = "TP,PP";
    switch (currentUser.eBizTitleCode) {
      case "NV":
      case "CV":
      case "DP":
        preApproverTitleCode = "DT,DP";
        approverTitleCode = "TP,PP";
        break;
      case "DT":
      case "PP":
        preApproverTitleCode = "TP,PP";
        approverTitleCode = "GD,PGD";
        break;
      case "TP":
      case "PGD":
        preApproverTitleCode = "GD,PGD";
        approverTitleCode = "TGD,PTGD";
        break;
      case "GD":
        preApproverTitleCode = "TGD,PTGD";
        approverTitleCode = "TGD,PTGD";
        break;
      case "PTGD":
        preApproverTitleCode = "TGD,PTGD";
        approverTitleCode = "";
        break;
      case "TGD":
        approverTitleCode = "";
        break;
      default:
        break;
    }
    const approvers = employees
      .filter((f: any) => approverTitleCode.indexOf(f.eBizTitleCode) > -1 && f.eDepartment === currentUser.eDepartment)
      .map((o: any) => ({ label: o.Title, value: o.eMail, default: o.eDefault || false }));
    const preapprovers = employees
      .filter(
        (f: any) => preApproverTitleCode.indexOf(f.eBizTitleCode) > -1 && f.eDepartment === currentUser.eDepartment,
      )
      .map((o: any) => ({ label: o.Title, value: o.eMail, default: o.eDefault || false }));
    setApproverOptions(approvers);
    setPreApproverOptions(preapprovers);
    if (approvers.length > 0) {
      const defaultApprover = approvers.find((a: any) => a.default);
      setApprover((defaultApprover && defaultApprover.value) || approvers[0].value);
    }
    if (preapprovers.length > 0) {
      const defaultPreApprover = preapprovers.find((a: any) => a.default);
      setPreApprover((defaultPreApprover && defaultPreApprover.value) || preapprovers[0].value);
    }
  };

  const getEmployeesWithId = () => {
    EmployeeService.getEmployeesWithId().then((res) => {
      setEmployeeids(res);
    });
  };

  useEffect(() => {
    if (employees && employees.length > 0) {
      checkCurrentUser();
    }
  }, [employees]);

  useEffect(() => {
    if (currentUser) {
      const { Title, eBizTitle, eDepartment, ePhone, eAddress } = currentUser;
      setValues({
        ...values,
        fullname: Title,
        role: eBizTitle,
        department: eDepartment,
        phone: ePhone,
        address: eAddress,
      });
      getApproverOptions();
    }
    getEmployeesWithId();
  }, [currentUser]);

  useEffect(() => {
    if (id != 0 && currentUser) {
      LeaveRequestService.getLeaveRequest(id)
        .then((res) => {
          const { eLeaveStartDate, eLeaveEndDate, eLeaveReason, ePreApprovedBy, eApprovedBy, eLeaveType } = res.fields;
          const approverEmail = (eApprovedBy && eApprovedBy.split("|")[0]) || "";
          const preApproverEmail = (ePreApprovedBy && ePreApprovedBy.split("|")[0]) || "";
          const startDate = new Date(eLeaveStartDate);
          const endDate = new Date(eLeaveEndDate);
          let fromSession = [];
          let toSession = [];
          if (startDate.getHours() == 8) {
            fromSession.push("SA");
          } else if (startDate.getHours() == 13) {
            fromSession.push("CH");
          } else {
            fromSession = ["SA", "CH"];
          }

          if (endDate.getHours() == 8) {
            toSession.push("SA");
          } else if (endDate.getHours() == 13) {
            toSession.push("CH");
          } else {
            toSession = ["SA", "CH"];
          }
          const { Title, eBizTitle, eDepartment, ePhone, eAddress } = currentUser;
          setValues({
            ...values,
            reason: eLeaveReason,
            fromSession,
            toSession,
            fullname: Title,
            role: eBizTitle,
            department: eDepartment,
            phone: ePhone,
            address: eAddress,
          });
          setLeaveType(eLeaveType);
          setApprover(approverEmail);
          setPreApprover(preApproverEmail);
          setStartDate(startDate);
          setEndDate(endDate);
        })
        .catch((error) => console.log(error));
    }
  }, [id, currentUser]);
  return (
    <div className="LeaveRequestCreateNewPage">
      <div className="pd15">
        <div className="PageHead">
          <div className="title">
            <div className="btnBack" onClick={() => history.push(Routes.procedureLeaveRequest.path)}>
              <Icon.ArrowLeft />
            </div>
            Danh sách đơn xin nghỉ phép
          </div>
        </div>

        <Box title="Thông tin">
          <form onSubmit={handleSubmit}>
            <div className="d-flex justify-content-center">
              <Container fluid className="px-0">
                <div className="user-info-container">
                  <Row>
                    <Col xs={12} md={6}>
                      <InputWraper inputProps={getInputProps("fullname")} renderInput={(s) => <InputText {...s} />} />
                    </Col>
                    <Col xs={12} md={6}>
                      <InputWraper inputProps={getInputProps("department")} renderInput={(s) => <InputText {...s} />} />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} md={6}>
                      <InputWraper inputProps={getInputProps("role")} renderInput={(s) => <InputText {...s} />} />
                    </Col>
                    <Col xs={12} md={6}>
                      <InputWraper inputProps={getInputProps("phone")} renderInput={(s) => <InputNumber {...s} />} />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} md={12}>
                      <InputWraper inputProps={getInputProps("address")} renderInput={(s) => <InputText {...s} />} />
                    </Col>
                  </Row>
                </div>
              </Container>
            </div>
            <InputWraper
              inputProps={getInputProps("type")}
              renderInput={(s) => (
                <InputSelect
                  {...s}
                  placeholder="Chọn loại nghỉ phép"
                  options={leaveRequestOptions}
                  value={leaveType}
                  onChange={onLeaveTypeChange}
                />
              )}
            />
            {preApproverOptions.length > 0 && (
              <InputWraper
                inputProps={getInputProps("preapprover")}
                renderInput={(s) => (
                  <UserSelect
                    {...s}
                    placeholder="Chọn người duyệt"
                    options={preApproverOptions}
                    value={preApprover}
                    onChange={onPreApproverChange}
                  />
                )}
              />
            )}
            {approverOptions.length > 0 && (
              <InputWraper
                inputProps={getInputProps("approver")}
                renderInput={(s) => (
                  <UserSelect
                    {...s}
                    placeholder="Chọn người duyệt"
                    options={approverOptions}
                    value={approver}
                    onChange={onApproverChange}
                  />
                )}
              />
            )}
            <InputWraper
              inputProps={getInputProps("from")}
              renderInput={(s) => (
                <>
                  <InputDateTime {...s} value={startDate} onChange={onStartDateChange} />
                  <div className="timeZoneCheckBoxs">
                    <InputCheckbox
                      label="Sáng"
                      name="time"
                      value={values["fromSession"].includes("SA")}
                      onTouched={() => false}
                      onChange={(e) =>
                        getInputProps("fromSession").onChange(
                          e ? [...values["fromSession"], "SA"] : values["fromSession"].filter((v: any) => v !== "SA"),
                        )
                      }
                    />

                    <InputCheckbox
                      label="Chiều"
                      name="time"
                      value={values["fromSession"].includes("CH")}
                      onTouched={() => false}
                      onChange={(e) =>
                        getInputProps("fromSession").onChange(
                          e ? [...values["fromSession"], "CH"] : values["fromSession"].filter((v: any) => v !== "CH"),
                        )
                      }
                    />
                  </div>
                </>
              )}
            />

            <InputWraper
              inputProps={getInputProps("to")}
              renderInput={(s) => (
                <>
                  <InputDateTime {...s} value={endDate} onChange={onEndDateChange} minDate={minDate} />

                  <div className="timeZoneCheckBoxs">
                    <InputCheckbox
                      label="Sáng"
                      name="time"
                      value={values["toSession"].includes("SA")}
                      onTouched={() => false}
                      onChange={(e) =>
                        getInputProps("toSession").onChange(
                          e ? [...values["toSession"], "SA"] : values["toSession"].filter((v: any) => v !== "SA"),
                        )
                      }
                    />

                    <InputCheckbox
                      label="Chiều"
                      name="time"
                      value={values["toSession"].includes("CH")}
                      onTouched={() => false}
                      onChange={(e) =>
                        getInputProps("toSession").onChange(
                          e ? [...values["toSession"], "CH"] : values["toSession"].filter((v: any) => v !== "CH"),
                        )
                      }
                    />
                  </div>
                </>
              )}
            />

            <InputWraper inputProps={getInputProps("reason")} component={InputTextArea} />

            <Button type="submit" label="Xác nhận" isLoading={isSubmitting} />
            <Button
              type="button"
              label="Huỷ"
              buttonType="grey-outline"
              className="ml10"
              onClick={() => history.push(Routes.procedureLeaveRequest.path)}
            />
          </form>
        </Box>
      </div>
    </div>
  );
});
